import React, { useRef } from 'react'
import Panel from '../../../shared/Panel'
import Loans from './Loans'
import EditLoan from './EditLoan'
import EditBalance from './EditBalance'
import { useOnClickOutside } from '../../../../hooks'

interface MortgagesPanelProps {
  editing: boolean
  editingBalance: number
  showPast: boolean
  setShowPast: () => void
  onClickOutside: () => void
}

const MortgagesPanel = ({
  editing,
  editingBalance,
  showPast,
  setShowPast,
  onClickOutside,
}: MortgagesPanelProps) => {
  const mortgagesContainerRef = useRef(null)
  useOnClickOutside(mortgagesContainerRef, onClickOutside)
  return (
    <div ref={mortgagesContainerRef}>
      <Panel data-qa='MortgagesCard'>
        {editing && <EditLoan />}
        {editingBalance && <EditBalance />}
        {!(editing || editingBalance) && (
          <Loans showPast={showPast} setShowPast={setShowPast} />
        )}
      </Panel>
    </div>
  )
}
export default MortgagesPanel
